window.bundleDataR = {
"Rachel-girl": {
displayName: "Rachel",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Rachel Personalized Coloring Experience",
variantId: "49614663319789",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rachel_final_cover.png?v=1773443857",
price: "$14.99",
preorder: true
},
{
title: "Rachel Unicorn Holographic Sticker",
variantId: "49933755941101",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rachel_holographic_sticker.png?v=1779378943",
price: "$4.99",
preorder: false
},
{
title: "Rachel Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Rafael-boy": {
displayName: "Rafael",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Rafael Personalized Coloring Experience",
variantId: "49411971350765",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/RAFAEL_FINAL_COVER.png?v=1772032668",
price: "$14.99",
preorder: true
},
{
title: "Rafael Dragon Holographic Sticker",
variantId: "49933767213293",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rafael_holographic_sticker.png?v=1780106109",
price: "$4.99",
preorder: false
},
{
title: "Rafael Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Randy-boy": {
displayName: "Randy",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Randy Personalized Coloring Experience",
variantId: "49431647322349",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Randy_final_cover.png?v=1772388164",
price: "$14.99",
preorder: true
},
{
title: "Randy Dragon Holographic Sticker",
variantId: "49933759774957",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Randy_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Randy Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Ray-boy": {
displayName: "Ray",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ray Personalized Coloring Experience",
variantId: "49658372489453",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ray_final_cover.png?v=1773501516",
price: "$14.99",
preorder: true
},
{
title: "Ray Dragon Holographic Sticker",
variantId: "49933754499309",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ray_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Ray Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Raymond-boy": {
displayName: "Raymond",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Raymond Personalized Coloring Experience",
variantId: "49657985040621",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Raymond_final_cover.png?v=1773501516",
price: "$14.99",
preorder: true
},
{
title: "Raymond Dragon Holographic Sticker",
variantId: "49933754532077",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Raymond_holographic_sticker.png?v=1780106103",
price: "$4.99",
preorder: false
},
{
title: "Raymond Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Rebecca-girl": {
displayName: "Rebecca",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Rebecca Personalized Coloring Experience",
variantId: "49929707520237",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rebecca_final_cover.png?v=1777863212",
price: "$14.99",
preorder: true
},
{
title: "Rebecca Unicorn Holographic Sticker",
variantId: "49933745488109",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rebecca_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Rebecca Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Remi-girl": {
displayName: "Remi",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Remi Personalized Coloring Experience",
variantId: "49279572967661",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Remi_final_cover.png?v=1773766535",
price: "$14.99",
preorder: true
},
{
title: "Remi Unicorn Holographic Sticker",
variantId: "49933773963501",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Remi_holographic_sticker.png?v=1780099045",
price: "$4.99",
preorder: false
},
{
title: "Remi Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Remy-boy": {
displayName: "Remy",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Remy Personalized Coloring Experience",
variantId: "49351816413421",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Remy_final_cover.png?v=1772753296",
price: "$14.99",
preorder: true
},
{
title: "Remy Dragon Holographic Sticker",
variantId: "49933770457325",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Remy_holographic_sticker.png?v=1780106111",
price: "$4.99",
preorder: false
},
{
title: "Remy Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Rhett-boy": {
displayName: "Rhett",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Rhett Personalized Coloring Experience",
variantId: "49472166789357",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rhett_final_cover.png?v=1772930020",
price: "$14.99",
preorder: true
},
{
title: "Rhett Dragon Holographic Sticker",
variantId: "49933759185133",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rhett_holographic_sticker.png?v=1780106103",
price: "$4.99",
preorder: false
},
{
title: "Rhett Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Rhys-boy": {
displayName: "Rhys",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Rhys Personalized Coloring Experience",
variantId: "49731771957485",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rhys_final_cover.png?v=1774739906",
price: "$14.99",
preorder: true
},
{
title: "Rhys Dragon Holographic Sticker",
variantId: "49933753614573",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rhys_holographic_sticker.png?v=1780106105",
price: "$4.99",
preorder: false
},
{
title: "Rhys Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Ricardo-boy": {
displayName: "Ricardo",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ricardo Personalized Coloring Experience",
variantId: "49411972071661",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/RICARDO_FINAL_COVER.png?v=1772032666",
price: "$14.99",
preorder: true
},
{
title: "Ricardo Dragon Holographic Sticker",
variantId: "49933767180525",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ricardo_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Ricardo Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Richard-boy": {
displayName: "Richard",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Richard Personalized Coloring Experience",
variantId: "49411974004973",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/RICHARD_FINAL_COVER.png?v=1772032667",
price: "$14.99",
preorder: true
},
{
title: "Richard Dragon Holographic Sticker",
variantId: "49933767147757",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Richard_holographic_sticker.png?v=1780106109",
price: "$4.99",
preorder: false
},
{
title: "Richard Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Rick-boy": {
displayName: "Rick",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Rick Personalized Coloring Experience",
variantId: "49431448453357",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rick_final_cover.png?v=1772388163",
price: "$14.99",
preorder: true
},
{
title: "Rick Dragon Holographic Sticker",
variantId: "49933760037101",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rick_holographic_sticker.png?v=1780106104",
price: "$4.99",
preorder: false
},
{
title: "Rick Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Riley-girl": {
displayName: "Riley",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Riley Personalized Coloring Experience",
variantId: "49615652585709",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Riley_final_cover.png?v=1773443858",
price: "$14.99",
preorder: true
},
{
title: "Riley Unicorn Holographic Sticker",
variantId: "49933755875565",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Riley_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Riley Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"River-boy": {
displayName: "River",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "River Personalized Coloring Experience",
variantId: "49351812448493",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/River_final_cover.png?v=1772753295",
price: "$14.99",
preorder: true
},
{
title: "River Dragon Holographic Sticker",
variantId: "49933770522861",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/River_holographic_sticker.png?v=1780106109",
price: "$4.99",
preorder: false
},
{
title: "River Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Riya-girl": {
displayName: "Riya",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Riya Personalized Coloring Experience",
variantId: "49612594020589",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Riya_final_cover.png?v=1773443856",
price: "$14.99",
preorder: true
},
{
title: "Riya Unicorn Holographic Sticker",
variantId: "49933756072173",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Riya_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Riya Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Rob-boy": {
displayName: "Rob",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Rob Personalized Coloring Experience",
variantId: "49400126963949",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rob_final_cover.png?v=1771691585",
price: "$14.99",
preorder: true
},
{
title: "Rob Dragon Holographic Sticker",
variantId: "49933769965805",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rob_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Rob Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Robert-boy": {
displayName: "Robert",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Robert Personalized Coloring Experience",
variantId: "49411978297581",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ROBERT_FINAL_COVER.png?v=1772032666",
price: "$14.99",
preorder: true
},
{
title: "Robert Dragon Holographic Sticker",
variantId: "49933767114989",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Robert_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Robert Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Roman-boy": {
displayName: "Roman",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Roman Personalized Coloring Experience",
variantId: "49411984031981",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ROMAN_FINAL_COVER.png?v=1772032669",
price: "$14.99",
preorder: true
},
{
title: "Roman Dragon Holographic Sticker",
variantId: "49933767082221",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Roman_holographic_sticker.png?v=1780106104",
price: "$4.99",
preorder: false
},
{
title: "Roman Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Romy-girl": {
displayName: "Romy",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Romy Personalized Coloring Experience",
variantId: "49608134131949",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Romy_final_cover.png?v=1773443858",
price: "$14.99",
preorder: true
},
{
title: "Romy Unicorn Holographic Sticker",
variantId: "49933756203245",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Romy_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Romy Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Rory-boy": {
displayName: "Rory",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Rory Personalized Coloring Experience",
variantId: "49709372145901",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rory_final_cover.png?v=1774104747",
price: "$14.99",
preorder: true
},
{
title: "Rory Dragon Holographic Sticker",
variantId: "49933753876717",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rory_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Rory Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Rose-girl": {
displayName: "Rose",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Rose Personalized Coloring Experience",
variantId: "49648019767533",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rose_final_cover.png?v=1773501522",
price: "$14.99",
preorder: true
},
{
title: "Rose Unicorn Holographic Sticker",
variantId: "49933755285741",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rose_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Rose Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Rowan-boy": {
displayName: "Rowan",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Rowan Personalized Coloring Experience",
variantId: "49279573098733",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rowanfinalcover.png?v=1772681630",
price: "$14.99",
preorder: true
},
{
title: "Rowan Dragon Holographic Sticker",
variantId: "49933773930733",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rowan_holographic_sticker.png?v=1780106105",
price: "$4.99",
preorder: false
},
{
title: "Rowan Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Ruby-girl": {
displayName: "Ruby",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ruby Personalized Coloring Experience",
variantId: "49639689126125",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ruby_final_cover.png?v=1773501522",
price: "$14.99",
preorder: true
},
{
title: "Ruby Unicorn Holographic Sticker",
variantId: "49933755547885",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ruby_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Ruby Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Ryan-boy": {
displayName: "Ryan",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ryan Personalized Coloring Experience",
variantId: "49265117266157",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ryanfinalcover.png?v=1772681896",
price: "$14.99",
preorder: true
},
{
title: "Ryan Dragon Holographic Sticker",
variantId: "49933781532909",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ryan_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Ryan Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Ryder-boy": {
displayName: "Ryder",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ryder Personalized Coloring Experience",
variantId: "49411985309933",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/RYDER_FINAL_COVER.png?v=1772032668",
price: "$14.99",
preorder: true
},
{
title: "Ryder Dragon Holographic Sticker",
variantId: "49933767016685",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ryder_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Ryder Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Raelynn-girl": {
displayName: "Raelynn",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Raelynn Personalized Coloring Experience",
variantId: "50056816525549",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Raelynn_final_cover.png?v=1780209146",
price: "$14.99",
preorder: true
},
{
title: "Raelynn Unicorn Holographic Sticker",
variantId: "50056840642797",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Raelynn_holographic_sticker.png?v=1780206654",
price: "$4.99",
preorder: false
},
{
title: "Raelynn Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Rylee-girl": {
displayName: "Rylee",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Rylee Personalized Coloring Experience",
variantId: "50056817475821",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rylee_final_cover.png?v=1780209145",
price: "$14.99",
preorder: true
},
{
title: "Rylee Unicorn Holographic Sticker",
variantId: "50056844312813",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rylee_holographic_sticker.png?v=1780206654",
price: "$4.99",
preorder: false
},
{
title: "Rylee Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Ryker-boy": {
displayName: "Ryker",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ryker Personalized Coloring Experience",
variantId: "50127702786285",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rykerfinalcover.png?v=1781988069",
price: "$14.99",
preorder: true
},
{
title: "Ryker Dragon Holographic Sticker",
variantId: "50127676702957",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rykerwebsitesticker.png?v=1781987198",
price: "$4.99",
preorder: false
},
{
title: "Ryker Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Reagan-girl": {
displayName: "Reagan",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Reagan Personalized Coloring Experience",
variantId: "50246042058989",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Reagan_final_cover.png?v=1783566389",
price: "$14.99",
preorder: true
},
{
title: "Reagan Unicorn Holographic Sticker",
variantId: "50259995361517",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Reagan_holographic_sticker.png?v=1783785471",
price: "$4.99",
preorder: false
},
{
title: "Reagan Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Reese-girl": {
displayName: "Reese",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Reese Personalized Coloring Experience",
variantId: "50246147014893",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Reese_final_cover.png?v=1783566389",
price: "$14.99",
preorder: true
},
{
title: "Reese Unicorn Holographic Sticker",
variantId: "50260005388525",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Reese_holographic_sticker.png?v=1783785471",
price: "$4.99",
preorder: false
},
{
title: "Reese Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Rosalie-girl": {
displayName: "Rosalie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Rosalie Personalized Coloring Experience",
variantId: "50274163032301",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rosalie_final_cover.png?v=1783795017",
price: "$14.99",
preorder: true
},
{
title: "Rosalie Unicorn Holographic Sticker",
variantId: "50274695250157",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rosalieholographicsticker.png?v=1783829023",
price: "$4.99",
preorder: false
},
{
title: "Rosalie Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Ruth-girl": {
displayName: "Ruth",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ruth Personalized Coloring Experience",
variantId: "50305430061293",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ruthfinalcover.png?v=1784425395",
price: "$14.99",
preorder: true
},
{
title: "Ruth Unicorn Holographic Sticker",
variantId: "50305506509037",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ruth_holographic_sticker.png?v=1784431196",
price: "$4.99",
preorder: false
},
{
title: "Ruth Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"River-girl": {
displayName: "River",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "River Personalized Coloring Experience",
variantId: "50305448935661",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Riverfinalcover.png?v=1784427401",
price: "$14.99",
preorder: true
},
{
title: "River Unicorn Holographic Sticker",
variantId: "50305508704493",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/River_holographic_sticker_10dc66af-9bb9-41d6-9527-8113c0cb411d.png?v=1784431196",
price: "$4.99",
preorder: false
},
{
title: "River Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Ryleigh-girl": {
displayName: "Ryleigh",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ryleigh Personalized Coloring Experience",
variantId: "50305428586733",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ryleighfinalcover.png?v=1784425052",
price: "$14.99",
preorder: true
},
{
title: "Ryleigh Unicorn Holographic Sticker",
variantId: "50305510637805",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ryleigh_holographic_sticker.png?v=1784431196",
price: "$4.99",
preorder: false
},
{
title: "Ryleigh Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Riley-boy": {
displayName: "Riley",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Riley Personalized Coloring Experience",
variantId: "50399446827245",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Riley_final_cover_6ce198b4-1b58-4814-b4e2-1fdde2be5bc7.png?v=1784947223",
price: "$14.99",
preorder: true
},
{
title: "Riley Dragon Holographic Sticker",
variantId: "50399567905005",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Riley_boy_holographic_sticker.png?v=1784945963",
price: "$4.99",
preorder: false
},
{
title: "Riley Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Remington-boy": {
displayName: "Remington",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Remington Personalized Coloring Experience",
variantId: "50399807799533",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Remingtonfinalcover.png?v=1785905486",
price: "$14.99",
preorder: true
},
{
title: "Remington Dragon Holographic Sticker",
variantId: "50449542185197",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Remington_holographic_sticker.png?v=1786244664",
price: "$4.99",
preorder: false
},
{
title: "Remington Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Ronan-boy": {
displayName: "Ronan",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ronan Personalized Coloring Experience",
variantId: "50457713180909",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ronan_final_cover.png?v=1786406747",
price: "$14.99",
preorder: true
},
{
title: "Ronan Dragon Holographic Sticker",
variantId: "50457555534061",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ronan_holographic_sticker.png?v=1786406786",
price: "$4.99",
preorder: false
},
{
title: "Ronan Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Rowan-girl": {
displayName: "Rowan",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Rowan Personalized Coloring Experience",
variantId: "50643939786989",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rowan_final_cover.png?v=1788490621",
price: "$14.99",
preorder: true
},
{
title: "Rowan Unicorn Holographic Sticker",
variantId: "50643952107757",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Rowan_girl_holographic_sticker.png?v=1788490590",
price: "$4.99",
preorder: false
},
{
title: "Rowan Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} 


 







};